export default "__VITE_ASSET__lEgLp6iU__"